import Vue from 'vue';
import VueI18n from 'vue-i18n';
import config from '@/config';

Vue.use(VueI18n);

const files = require.context('./translations', false, /\.json$/);
const messages = {};
files.keys().forEach(key => {
  messages[key.replace(/(\.\/|\.json)/g, '')] = files(key);
});

export default new VueI18n({
  locale: config.default_language,
  fallbackLocale: config.default_language,
  messages,
  silentTranslationWarn: config.is_development,
});
